import styled from 'styled-components'

interface MobileWidgetGradientCardNameIconStyledProps {
    color?: string;
    disabled?: boolean;
    gradientEnd: string;
    gradientStart: string;
}

export const MobileWidgetGradientCardNameIconStyled = styled.div<MobileWidgetGradientCardNameIconStyledProps>`
    flex-grow: 0;
    flex-shrink: 0;
    padding: 16px;
    border-radius: 16px;
    height: 128px;
    width: 184px;
    background: linear-gradient(135deg, ${props => props.gradientStart} 1.2%, ${props => props.gradientEnd} 101.2%);
    color: ${props => props.color || 'var(--text-color-dark)'};
    position: relative;
    overflow: hidden;
    pointer-events: ${({disabled}) => (disabled ? 'none' : 'auto')};
    
    h4 {
        font-weight: 600;
        font-size: 16px;
    }
`;

export const MobileWidgetGradientCardNameIconContainerStyled = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    
    h4 {
        z-index: 1;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-clamp: 2;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const MobileWidgetGradientCardNameIconButtonStyled = styled.button`
    background: var(--color-button-secondary-default);
    border: none;
    padding: 12px;
    border-radius: 12px;
    color: var(--color-label-neutral-primary-black);
`;

export const MobileWidgetGradientCardNameIconImgStyled = styled.img`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 110px !important;
    height: 86px;
    
    &.hidden {
        display: none;
    }
`;

export const MobileWidgetGradientCardNameIconWrapperStyled = styled.div`
    position: absolute;
    bottom: -33px;
    right: -10px;
`;

export const MobileWidgetGradientCardNameIconDefaultStyled = styled.div`
    width: 120px;
    height: 120px;
    border-radius: 60px;
    background: var(--color-neutral-20);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: -35px;
    right: -10px;
    color: var(--text-color-dark);
    font-weight: 600;
    font-size: 40px;
`;
